export default {
    default: "http://apfelkiste.ch/WebPage",
    account: "http://apfelkiste.ch/WebPage/Account",
    cart: "http://apfelkiste.ch/WebPage/Cart",
    checkout: "http://apfelkiste.ch/WebPage/Checkout",
    checkoutConfirmation: "http://apfelkiste.ch/WebPage/CheckoutConfirmation",
    passwordReset: "http://apfelkiste.ch/WebPage/PasswordReset",
    rma: "http://apfelkiste.ch/WebPage/Rma",
    designer: "http://apfelkiste.ch/WebPage/Designer",
    styleguide: "http://apfelkiste.ch/WebPage/Styleguide",
    tradein: "http://apfelkiste.ch/WebPage/Tradein",
    product: "http://apfelkiste.ch/WebPage/Item",
    category: "http://apfelkiste.ch/WebPage/Collection",
    search: "http://apfelkiste.ch/WebPage/SearchResults",
    signupConfirmation: "http://apfelkiste.ch/WebPage/SignupConfirmation",

    error: "http://apfelkiste.ch/WebPage/Error",
    error404: "http://apfelkiste.ch/WebPage/Error/404",
    fallback: "http://apfelkiste.ch/WebPage/Fallback",
};
